import { CellDef, Styles } from "jspdf-autotable";

import { DriverContact } from "../../drivers.types";

interface getContactsProps {
  driverContacts: DriverContact[];
  normalFontStyles: Partial<Styles>;
}

export const getContacts = ({
  driverContacts,
  normalFontStyles
}: getContactsProps) => {
  const contacts = driverContacts
    ? driverContacts.map((contact) => {
        const emails = contact.emails.join("\n");
        const phoneNumbers = contact.phoneNumbers.join("\n");

        const firstCell: CellDef = {
          content: `${contact.name}`,
          styles: {
            valign: "middle",
            halign: "left",
            ...normalFontStyles
          }
        };
        const secondCell: CellDef = {
          content: phoneNumbers,
          styles: {
            valign: "middle",
            halign: "right",
            ...normalFontStyles
          }
        };
        const thirdCell: CellDef = {
          content: emails,
          styles: {
            valign: "middle",
            halign: "right",
            ...normalFontStyles
          }
        };

        return [firstCell, secondCell, thirdCell];
      })
    : [{ content: "" }];

  return { contacts };
};
